// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-gallery_layout__m1BSW","slide":"layout-gallery_slide__CvI1E"};